import React from 'react';
import PropTypes from 'prop-types';

import hugggB2BLogo from 'assets/img/logos/b2b-huggg-logo.svg';
import hugggB2GLogo from 'assets/img/logos/b2g-huggg-logo-dark.svg';
import dictionary from 'config/dictionary';
import { useThemeContext } from '@huggg/react-components';

import styles from './powered-by-huggg.module.scss';

const PoweredByHuggg = (props) => {
  const { isWelfare } = useThemeContext();

  const logo = isWelfare ? hugggB2GLogo : hugggB2BLogo;

  return (
    <div className={styles.poweredByHuggg}>
      Powered by{' '}
      <img src={logo} alt={dictionary.hugggLogoAlt} className={styles.logo} />
    </div>
  );
};

PoweredByHuggg.propTypes = {
  className: PropTypes.string,
};

export default PoweredByHuggg;
